var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"float":"right"}},[_vm._l((_vm.langs),function(lang,key){return [_c('span',{key:lang.flags,staticClass:"flag-icon",class:_vm.flags(lang.flags),staticStyle:{"width":"20px","cursor":"pointer"},on:{"click":function($event){return _vm.setLang(key)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }